import { LoadingSpinner } from "@common/components/ui/loading-spinner"
import { useInfiniteScroll } from "@common/hooks/use-infinite-scroll"
import { useContext } from "react"
import { GroupOpenContext } from "./grouped-table"
import { LoadMoreError } from "./load-more-error"

export function LoadMoreSentinel({
  noun,
  hasNextPage,
  isFetchingNextPage,
  isError,
  fetchNextPage,
}: {
  noun: string
  hasNextPage: boolean
  isFetchingNextPage: boolean
  isError: boolean
  fetchNextPage: () => void
}): React.ReactElement | null {
  const groupOpen = useContext(GroupOpenContext)
  const sentinelRef = useInfiniteScroll({
    hasNextPage: hasNextPage && groupOpen,
    isFetchingNextPage,
    isError,
    fetchNextPage,
  })

  if (!hasNextPage) {
    return null
  }

  if (isError) {
    return (
      <div className="px-2 py-3">
        <LoadMoreError
          message={`Couldn't load more ${noun}.`}
          onRetry={() => fetchNextPage()}
        />
      </div>
    )
  }

  return (
    <div ref={sentinelRef} className="flex justify-center py-4">
      {isFetchingNextPage && <LoadingSpinner className="size-5" />}
    </div>
  )
}
